import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const AllFirms = () => {
  const [firms, setFirms] = useState([]);
  const [formData, setFormData] = useState({ firmName: "" });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchFirms();
  }, []);

  const fetchFirms = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/get-firms`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      setFirms(res.data.firms);
    } catch (err) {
      console.error(
        "Error fetching firms:",
        err.response?.data?.message || err.message
      );
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, firmName: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.firmName.trim()) {
      setMessage("⚠️ Firm name is required.");
      return;
    }

    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/add-firm`,
        formData,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      Swal.fire("Success!", "Firm added successfully", "success");
      setFormData({ firmName: "" });
      fetchFirms();
      setMessage("");
    } catch (err) {
      Swal.fire(
        "Error!",
        err.response?.data?.message || "Failed to add firm.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this firm?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        const res = await axios.delete(
          `${process.env.REACT_APP_API_URL}/api/delete-firm/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire("Deleted!", res.data.message, "success");
        fetchFirms();
      } catch (err) {
        Swal.fire(
          "Error!",
          err.response?.data?.message || "Failed to delete firm.",
          "error"
        );
      }
    }
  };

  return (
    <div
      className="container mt-5"
      style={{ minHeight: "80vh", backgroundColor: "#f0f8ff" }}
    >
      <h1 className="mb-4 text-center">Firm Management</h1>

      <div className="card p-4 mb-4 shadow-sm">
        <h2 className="h5 mb-3">Add New Firm</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3 row">
            <div className="col-12">
              <input
                type="text"
                name="firmName"
                placeholder="Firm Name"
                value={formData.firmName}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn btn-outline-primary w-100 fw-bold"
          >
            {loading ? "Adding..." : "Add Firm"}
          </button>
        </form>
        {message && <p className="text-danger mt-2">{message}</p>}
      </div>

      <div className="card p-4 shadow-sm table-responsive">
        <h2 className="h5 mb-3">Firm List</h2>
        {firms.length === 0 ? (
          <p className="text-muted">No firms found.</p>
        ) : (
          <table className="table table-striped text-center">
            <thead className="table-dark">
              <tr>
                <th>Firm Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {console.log("FIRMS", firms)}
              {firms.length === 0 ? (
                <tr>
                  <td colSpan="2" className="text-muted text-center">
                    No firms found.
                  </td>
                </tr>
              ) : (
                firms.map((firm) => (
                  <tr key={firm._id}>
                    <td>{firm.firmName}</td>
                    <td>
                      <button
                        className="btn btn-danger btn-sm fw-bold"
                        onClick={() => handleDelete(firm._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AllFirms;
